import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, withDefaults } from 'vue'
import * as echarts from 'echarts'
import BaseChart from '@/base-ui/chart'


export default _defineComponent({
  props: {
    title: { type: String, required: false, default: '' },
    xLabels: { type: Array, required: true },
    yValues: { type: Array, required: true }
  } as unknown as undefined,
  setup(__props: {
    title?: string
    xLabels: string[]
    yValues: any[]
  }) {

const props = __props


const options = computed(() => {
  return {
    title: {
      text: '支持滑鼠滾動縮放'
      // subtext: 'Feature Sample: Gradient Color, Shadow, Click Zoom'
    },
    xAxis: {
      data: props.xLabels,
      axisLabel: {
        inside: true,
        color: '#fff'
        // textStyle: {
        //   color: '#fff'
        // }
      },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      z: 10
    },
    yAxis: {
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        color: '#999'
        // textStyle: {
        //   color: '#999'
        // }
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '7%',
      containLabel: true
    },
    dataZoom: [
      {
        type: 'inside'
      }
    ],
    series: [
      {
        type: 'bar',
        showBackground: true,
        itemStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#83bff6' },
            { offset: 0.5, color: '#188df0' },
            { offset: 1, color: '#188df0' }
          ])
        },
        emphasis: {
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#2378f7' },
              { offset: 0.7, color: '#2378f7' },
              { offset: 1, color: '#83bff6' }
            ])
          }
        },
        data: props.yValues
      }
    ]
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(BaseChart), { options: _unref(options) }, null, 8, ["options"])
  ]))
}
}

})